import { useCallback, useMemo, useState } from 'react'

export function useModal() {
  const [isOpen, toggle] = useState<boolean>(false)
  const close = useCallback(() => toggle(false), [toggle])
  const open = useCallback(() => toggle(true), [toggle])
  return useMemo(() => ({ isOpen, toggle, open, close }), [isOpen, toggle, open, close])
}
